import { DateTime } from "luxon";

export function transformTimestampToLastUpdated(timestamp: DateTime): string {
  // If the timestamp is within the last 60 seconds, return "just now"
  if (timestamp.diffNow("seconds").seconds * -1 <= 60) {
    return "Updated just now";
  }
  // Else If the timestamp is less than 120 seconds, return "1 minute ago"
  else if (timestamp.diffNow("seconds").seconds * -1 <= 120) {
    return "Updated 1 minute ago";
  }
  // Else If the timestamp is within the last 60 minutes, return "x minutes ago"
  else if (timestamp.diffNow("minutes").minutes * -1 <= 60) {
    return `Updated ${Math.round(timestamp.diffNow("minutes").minutes * -1)} minutes ago`;
  }
  // Else If the timestamp is within the last 120 minutes, return "1 hour ago"
  else if (timestamp.diffNow("minutes").minutes * -1 <= 120) {
    return "Updated 1 hour ago";
  }
  // Else return "x hours ago"
  else {
    return `Updated ${Math.round(timestamp.diffNow("hours").hours * -1)} hours ago`;
  }
}
